// extracted by mini-css-extract-plugin
export var image = "bellTowerTreasures-module--image--3752a";
export var imageContainer = "bellTowerTreasures-module--imageContainer--9168c";
export var outerContainer = "bellTowerTreasures-module--outerContainer--5bcbc";
export var smallText = "bellTowerTreasures-module--smallText--d94bf";
export var text = "bellTowerTreasures-module--text--16087";
export var textContainer = "bellTowerTreasures-module--textContainer--fad2f";
export var title = "bellTowerTreasures-module--title--0c36c";